import { useContext, useState } from "react";
import { Col, Container, Row, Button, Card, CardBody } from "reactstrap";
import { Link } from 'react-scroll';
import logoSoal from '../../../assets/images/game/w2_assets/Questionbar.png'
import Pilihan1 from '../../../assets/images/game/w2_soal/no-1/no-1-1.png'
import Pilihan2 from '../../../assets/images/game/w2_soal/no-1/no-1-2.png'
import Pilihan3 from '../../../assets/images/game/w2_soal/no-1/no-1-3.png'
import Pilihan4 from '../../../assets/images/game/w2_soal/no-1/no-1-4.png'
import Pilihan5 from '../../../assets/images/game/w2_soal/no-1/no-1-5.png'
import AnswerTrue from '../../../assets/images/game/w2_soal/no-1/NOMOR 1 BENAR.png'
import AnswerFalse from '../../../assets/images/game/w2_soal/no-1/NOMOR 1 SALAH.png'
import { Context } from "../../../contexts/reducer/store";
import CheckAnswer from "../CheckAnswer";
import hiasan5 from '../../../assets/images/game/w2_assets/Asset-72.png'
import hiasan6 from '../../../assets/images/game/w2_assets/Asset-65.png'
import hiasan8 from '../../../assets/images/game/w2_assets/AdkBQM-full.png';
import Left from '../../../assets/images/game/w2_assets/question-title-left.png';
import Right from '../../../assets/images/game/w2_assets/question-title-right.png';

const Soal1 = () => {

    let [isOpen, setIsOpen] = useState(false);
    let [isTrue, setIsTrue] = useState(false);

    const [state, dispatch] = useContext(Context);
    const [disabled, setDisabled] = useState(false);

    const toggleModal = ( type ) => {
        setIsOpen(!isOpen);
        setIsTrue(type);
        setDisabled(true);
    };

    function SET_MARK ( value = Number ) {
        const init = {...state};
        let __mark = init.mark
        dispatch({type: 'SET_MARK', payload: __mark + value});
    }

    const Answer = () => {
        return (
            <>
                <img className="img-fluid" src={isTrue ? AnswerTrue : AnswerFalse} alt="" />
                <div className={`bg-light-green text-center py-1 ${isTrue ? 'd-none' : 'd-block'} my-3`}>
                    Jawaban yang benar pada soal adalah <b>2,3, dan 4.</b>
                </div>
            </>
        )
    }

    return (
        <>
            <Container className="front">
                <CheckAnswer Type={isTrue} isOpen={isOpen} setIsOpen={setIsOpen}>
                    <Answer />
                </CheckAnswer>
                <Row className="justify-content-center">
                    <Col md="12" className="text-center">
                        <Row className="mb-5 game-px">
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Left} alt=""/>
                            </Col>
                            <Col lg="10" md="10" sm="10" xs="10" className="my-auto">
                                <Card className="card-title-quiz">
                                    <CardBody>
                                        <h2 className="montserrat text-white">
                                            DI BAWAH INI, APA SAJA YANG TERMASUK <br /><b>KRITERIA INFORMASI DAPAT DISEBUT SEBAGAI <br /> HOAKS</b>?
                                        </h2>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Right} alt="" />
                            </Col>
                        </Row>
                        <Row className="mb-5 game-px">
                            <Col md="12" className="position-relative">
                                <div className="soal-1-game p-4">
                                    <Row>
                                        <Col md="6" className="d-flex justify-content-center align-self-center">
                                            <img src={Pilihan1} alt="clicked" className="img-fluid" />
                                        </Col>
                                        <Col md="6" className="d-flex justify-content-center align-self-center">
                                            <img src={Pilihan2} alt="clicked" className="img-fluid" />
                                        </Col>
                                        <Col md="12" className="d-flex justify-content-center align-self-center">
                                            <img src={Pilihan3} alt="clicked" className="img-fluid" />
                                        </Col>
                                        <Col md="6" className="d-flex justify-content-center align-self-center">
                                            <img src={Pilihan4} alt="clicked" className="img-fluid" />
                                        </Col>
                                        <Col md="6" className="d-flex justify-content-center align-self-center">
                                            <img src={Pilihan5} alt="clicked" className="img-fluid" />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>   
                        </Row>
                        {
                            disabled === false
                            ?   <Row className="w-100 game-px mr-0">
                                    <Col md="4" className="text-center p-0">
                                        <Link to="q2" spy={true} smooth={true} className="btn btn-jawaban w-100" onClick={() => { toggleModal(false)} }>1, 2, DAN 3</Link>
                                    </Col>
                                    <Col md="4" className="text-center p-0">
                                        <Link to="q2" spy={true} smooth={true} className="btn btn-jawaban w-100" onClick={() => (toggleModal(true), SET_MARK(1))}>2, 3, DAN 4</Link>
                                    </Col>
                                    <Col md="4" className="text-center p-0">
                                        <Link to="q2" spy={true} smooth={true} className="btn btn-jawaban w-100" onClick={() => (toggleModal(false))}>3, 4, DAN 5</Link>
                                    </Col>
                                </Row>
                            : <Row className="w-100 game-px mr-0">
                                <Col md="4" className="text-center p-0">
                                    <Button className="btn btn-jawaban montserrat w-100" disabled >1, 2, DAN 3</Button>
                                </Col>
                                <Col md="4" className="text-center p-0">
                                    <Button className="btn btn-jawaban montserrat w-100" disabled >2, 3, DAN 4</Button>
                                </Col>
                                <Col md="4" className="text-center p-0">
                                    <Button className="btn btn-jawaban montserrat w-100" disabled >3, 4, DAN 5</Button>
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
            </Container>
            <div className="position-relative img-asset">
                <img src={hiasan5} alt="" className="asset-5" />
                <img src={hiasan6} alt="" className="asset-6" />
                <img src={hiasan8} alt="" className="asset-8" />
            </div>
        </>
    )
}



export default Soal1